import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import { not } from 'ember-truth-helpers';

import UiButton from '../ui-button';

type UiCursorPaginationSignature = {
  Args: {
    nextCursor: string;
    previousCursor: string;
    setCursor: (cursor: string | null) => void;
  };
  Element: HTMLDivElement;
};

export default <template>
  <div class="w-full" ...attributes data-test-ui-cursor-pagination>
    <div class="flex float-right">
      <UiButton data-test-ui-pagination-first-page disabled={{not @previousCursor}} {{on "click" (fn @setCursor null)}}>
        {{svgJar "chevron-grey-first" height="16" width="16" class="-mb-0.5 mx-3"}}
      </UiButton>
      <UiButton
        data-test-ui-pagination-previous-page
        disabled={{not @previousCursor}}
        {{on "click" (fn @setCursor @previousCursor)}}
      >
        {{svgJar "chevron-grey-left" height="16" width="16" class="-mb-0.5 mx-3"}}
      </UiButton>
      <UiButton
        data-test-ui-pagination-next-page
        disabled={{not @nextCursor}}
        {{on "click" (fn @setCursor @nextCursor)}}
      >
        {{svgJar "chevron-grey-right" height="16" width="16" class="-mb-0.5 mx-3"}}
      </UiButton>
    </div>
  </div>
</template> satisfies TOC<UiCursorPaginationSignature>;
